import React from 'react'
import type { WellnessPlanCoverItem } from '@pbt/pbt-ui-components'

import {
  wellnessPlansCatalogActions,
  wellnessPlansCatalogSelectors,
} from '~/store/duck/wellnessPlansCatalog'

import AddCatalogItemsDialog, {
  type AddCatalogItemsDialogProps,
} from './AddCatalogItemsDialog'

interface AddWellnessPlanCoverageItemsDialogProps
  extends Omit<AddCatalogItemsDialogProps, 'actions' | 'selectors' | 'onSave'> {
  onSave: (cover: WellnessPlanCoverItem[]) => void
}

const AddWellnessPlanCoverageItemsDialog = (
  props: AddWellnessPlanCoverageItemsDialogProps,
) => (
  <AddCatalogItemsDialog
    actions={
      wellnessPlansCatalogActions as AddCatalogItemsDialogProps['actions']
    }
    selectors={
      wellnessPlansCatalogSelectors as AddCatalogItemsDialogProps['selectors']
    }
    {...props}
    onSave={(items) =>
      props.onSave(
        items.map((item) => ({
          name: item.name,
          itemId: item.id,
          itemType: item.type,
        })),
      )
    }
  />
)

export default AddWellnessPlanCoverageItemsDialog
